var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512pt",
    viewBox: "-11 0 512 512",
    width: "512pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 490.539062 200.679688 L 490.539062 512 L 0 512 L 0 200.679688 L 245.269531 8.328125 Z M 490.539062 200.679688 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#9DCB2C",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 490.539062 200.679688 L 490.539062 512 L 245.441406 512 C 245.328125 511.351562 245.269531 510.679688 245.269531 510 L 245.269531 8.328125 Z M 490.539062 200.679688 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#5C9506",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.96875 0 L 416.570312 0 L 416.570312 415.679688 L 73.96875 415.679688 Z M 73.96875 0 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#D7D3C8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245.269531 0 L 416.570312 0 L 416.570312 415.679688 L 245.269531 415.679688 Z M 245.269531 0 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#D7D3C8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 490.539062 200.789062 L 490.539062 512 L 0 512 L 0 200.789062 L 245.269531 393.140625 Z M 490.539062 200.789062 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#9DCB2C",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 490.539062 200.789062 L 490.539062 512 L 245.441406 512 C 245.328125 511.351562 245.269531 510.679688 245.269531 510 L 245.269531 393.140625 Z M 490.539062 200.789062 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#5C9506",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245.269531 65 C 182.410156 65 131.269531 116.140625 131.269531 179 C 131.269531 241.859375 182.410156 293 245.269531 293 C 257.078125 293 268.71875 291.199219 279.878906 287.648438 L 270.78125 259.058594 C 262.570312 261.671875 253.988281 263 245.269531 263 C 198.949219 263 161.269531 225.320312 161.269531 179 C 161.269531 132.679688 198.949219 95 245.269531 95 C 291.589844 95 329.269531 132.679688 329.269531 179 L 329.269531 215.789062 C 329.269531 224.769531 321.960938 232.078125 312.980469 232.078125 C 304 232.078125 296.691406 224.769531 296.691406 215.789062 L 296.691406 129.738281 L 269.789062 129.738281 C 262.269531 126.019531 253.941406 124.03125 245.390625 124.03125 L 245.269531 124.03125 C 215.011719 124.101562 190.429688 148.730469 190.429688 179 C 190.429688 209.269531 215.011719 233.898438 245.269531 233.96875 L 245.390625 233.96875 C 253.550781 233.96875 261.421875 232.199219 268.578125 228.859375 C 274.238281 248.039062 292 262.078125 312.980469 262.078125 C 338.5 262.078125 359.269531 241.308594 359.269531 215.789062 L 359.269531 179 C 359.269531 116.140625 308.128906 65 245.269531 65 Z M 266.691406 192.03125 C 265.699219 193.640625 264.539062 195.140625 263.199219 196.5 C 258.46875 201.308594 252.140625 203.96875 245.390625 203.96875 L 245.269531 203.96875 C 231.558594 203.898438 220.429688 192.730469 220.429688 179 C 220.429688 165.269531 231.558594 154.101562 245.269531 154.03125 L 245.390625 154.03125 C 251.539062 154.03125 257.441406 156.28125 262.011719 160.371094 C 263.851562 162.011719 265.421875 163.890625 266.691406 165.960938 Z M 266.691406 192.03125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#28182A",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 270.78125 259.058594 L 279.878906 287.648438 C 268.71875 291.199219 257.078125 293 245.269531 293 L 245.269531 263 C 253.988281 263 262.570312 261.671875 270.78125 259.058594 Z M 270.78125 259.058594 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#D7D3C8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 359.269531 179 L 359.269531 215.789062 C 359.269531 241.308594 338.5 262.078125 312.980469 262.078125 C 292 262.078125 274.238281 248.039062 268.578125 228.859375 C 261.421875 232.199219 253.550781 233.96875 245.390625 233.96875 L 245.269531 233.96875 L 245.269531 203.96875 L 245.390625 203.96875 C 252.140625 203.96875 258.46875 201.308594 263.199219 196.5 C 264.539062 195.140625 265.699219 193.640625 266.691406 192.03125 L 266.691406 165.960938 C 265.421875 163.890625 263.851562 162.011719 262.011719 160.371094 C 257.441406 156.28125 251.539062 154.03125 245.390625 154.03125 L 245.269531 154.03125 L 245.269531 124.03125 L 245.390625 124.03125 C 253.941406 124.03125 262.269531 126.019531 269.789062 129.738281 L 296.691406 129.738281 L 296.691406 215.789062 C 296.691406 224.769531 304 232.078125 312.980469 232.078125 C 321.960938 232.078125 329.269531 224.769531 329.269531 215.789062 L 329.269531 179 C 329.269531 132.679688 291.589844 95 245.269531 95 L 245.269531 65 C 308.128906 65 359.269531 116.140625 359.269531 179 Z M 359.269531 179 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#28182A",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.08149c5142bb96bf3a8c201c9d41dadc.svg";
export { ForwardRef as ReactComponent };